<template>
  <BackgroundMetaLayout v-if="route.meta.layout" :layout="route.meta.layout" />
  <div
    v-else
    class="main-layout grid h-full"
    :class="{
      'previous-provider-decision': showPreviousProviderDecision,
    }"
  >
    <div class="main-header mx-6 mt-6 xl:m-6 xl:p-4">
      <PageHeader />
    </div>

    <div v-if="showPreviousProviderDecision" class="h-min">
      <PreviousProviderDecisionViews />
    </div>

    <div
      class="main-content mx-4 rounded-lg bg-white shadow-lg xl:m-6 xl:mr-12 xl:max-w-screen-lg"
    >
      <router-view :key="route.fullPath" />
    </div>

    <div class="main-footer w-max justify-self-center p-2 xl:pb-4">
      <ApplicationFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue"
  import { usePreviousManuallySubmittedProviderResponses } from "@versatile-credit-apply/composition"
  import PageHeader from "@/components/layout/PageHeader.vue"
  import PreviousProviderDecisionViews from "@/views/apply/PreviousProviderDecisionViews.vue"
  import { useEvaluateRouteCondition } from "@versatile-credit-apply/sdk"
  import { useRoute } from "vue-router"
  import { ApplicationFooter } from "@versatile-credit-apply/components"
  import BackgroundMetaLayout from "./BackgroundMetaLayout.vue"
  import { useI18n } from "vue-i18n"

  useI18n()
  const route = useRoute()

  const responses = usePreviousManuallySubmittedProviderResponses()
  const showPreviousDecision = useEvaluateRouteCondition(
    (meta) => meta.showPreviousDecision
  )
  const showPreviousProviderDecision = computed(
    () => responses.value?.length > 0 && showPreviousDecision.value
  )
</script>

<style scoped>
  @reference "@/main.css";

  .main-layout {
    grid-template:
      "header" max-content
      "content" 1fr
      "footer" max-content
      / 1fr;
  }

  .main-layout.previous-provider-decision {
    grid-template:
      "header" max-content
      "previous" max-content
      "content" 1fr
      "footer" max-content
      / 1fr;
  }

  @variant xl {
    .main-layout {
      grid-template:
        "header content" minmax(0, 1fr)
        "footer content" max-content
        / 1fr minmax(0, 1024px);
    }

    .main-layout.previous-provider-decision {
      grid-template:
        "header previous" max-content
        "header content" minmax(0, 1fr)
        "footer content" max-content
        / 1fr minmax(0, 1024px);
    }
  }

  .main-layout .main-header {
    grid-area: header;
  }

  .main-layout .main-content {
    grid-area: content;
  }

  .main-layout .main-footer {
    grid-area: footer;
  }
</style>
